const CURRENCY_META = {
  USD: { symbol: '$', locale: 'en-US' },
  EUR: { symbol: '€', locale: 'de-DE' },
  BYN: { symbol: 'ў', locale: 'be-BY' },
  RUB: { symbol: '₽', locale: 'ru-RU' },
};

export const SUPPORTED_CURRENCIES = ['USD', 'EUR', 'BYN', 'RUB'];

export function getCurrencyMeta(code) {
  return CURRENCY_META[code] || CURRENCY_META.USD;
}

export function getCurrencySymbol(code) {
  return getCurrencyMeta(code).symbol ?? code;
}

export function formatCurrency(value, code = 'USD', options = {}) {
  if (Number.isNaN(value) || value === null || value === undefined) {
    return '—';
  }
  const { locale } = getCurrencyMeta(code);
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
    maximumFractionDigits: options.maximumFractionDigits ?? 2,
    minimumFractionDigits: options.minimumFractionDigits ?? 2,
  });
  return formatter.format(value);
}

export function formatNumber(value, digits = 2) {
  if (Number.isNaN(value) || value === null || value === undefined) {
    return '—';
  }
  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
}

export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function toNumber(raw) {
  if (typeof raw === 'number') {
    return raw;
  }
  if (typeof raw !== 'string') {
    return NaN;
  }
  const normalized = raw.replace(/\s/g, '').replace(',', '.');
  return Number(normalized);
}

export function padZero(value) {
  return value < 10 ? `0${value}` : `${value}`;
}
